module.exports = __webpack_public_path__ + "static/img/14010003.8e30743b.png";